import { Record } from 'immutable';

export default class PushNotificationRecord extends Record({
  id: undefined,
  title: undefined,
  body: undefined,
  notificationType: undefined,
  status: undefined,
  createdAt: undefined,
  sentAt: undefined,
  deliveredAt: undefined,
  readAt: undefined,
  errorMessage: undefined,
  createdBy: undefined,
  resource: undefined,
  _type: undefined,
}) {
}
